/* eslint-disable import/no-import-module-exports */
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from 'store/redux';
import { isDemoAccess, startDemoAccess } from 'features/demoAccess';
import CatchError from 'Catch';
import { App } from './App';
import './index.css';
// import { trackTranslation } from 'utils/trackTranslation';

const MOUNT_NODE = document.getElementById('root') as HTMLElement;

//  trackTranslation(MOUNT_NODE);

const root = createRoot(MOUNT_NODE); // createRoot(container!) if you use TypeScript

const init = isDemoAccess() ? startDemoAccess() : Promise.resolve();

init
  .then(() => {
    root.render(
      <CatchError>
        <Provider store={store}>
          <App />
        </Provider>
      </CatchError>
    );
  })
  .catch(console.error);
